<template>
    <div v-if="show" class="py-24" :style="{ background: data.Background ? `url('/file/${data.Background}') center center / cover no-repeat` : 'transparent' }">
        <div class="container flex justify-center lg:block">
            <div class="grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4">
                <div v-for="(item, index) in data.Items" :key="item.Id" class="flex lg:justify-center">
                    <div class="flex items-center">
                        <div class="flex items-center mr-4 w-44 lg:w-auto">
                            <div class="text-bigtitle text-secondary font-bold">
                                <animated-number :value="item.Name" :duration="2000" :delay="1000 + (index * 500)" :round="1"></animated-number>
                            </div>
                            <div v-if="item.Symbol != ''" class="ml-2 text-bigtitle text-secondary font-bold">{{ item.Symbol }}</div>
                        </div>
                        <div v-html="item.Content" class="prose leading-tight text-lg font-semibold"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnimatedNumber from "animated-number-vue";

export default {
    name: "Innumbers",
    props: ["data"],
    components: { AnimatedNumber },
    data() {
        return {

        }
    },
    computed: {
        show() {
            return this.data && Array.isArray(this.data.Items) && this.data.Items.length;
        }
    }
}
</script>

<style>

</style>